import { DateTime } from "luxon";

export const toUtcMidnight = (date: Date) => {
  const local = DateTime.fromJSDate(date);
  return DateTime.utc(local.year, local.month, local.day).toJSDate();
};
